module.exports = "/_next/static/images/31b9ce9a06b90b3dace9ad065412661c-2-women-working-landscape@2x.jpg.webp";